<script>
  export let content = '';
  export let idUnico = 'pergunta';
</script>

<div class="container">
  <div class="pergunta">
    <h3>{content}</h3>
  </div>
</div>

<style>
  .pergunta h3 {
    color: var(--MARROM);
    font-style: italic;
    font-size: 20px;
    font-weight: 500;
    font-family: var(--FONT_LORA);
  }

  .container {
    margin-bottom: -0.75rem;
  }

  @media (max-width: 768px) {
  }
</style>
